var _path, _rect, _mask, _path2, _rect2, _mask2, _path3, _mask3, _path4, _rect3, _mask4, _path5, _mask5, _path6, _rect4, _mask6, _path7, _rect5, _mask7, _path8, _mask8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5H80C84.1421 0.5 87.5 3.85786 87.5 8V80C87.5 84.1421 84.1421 87.5 80 87.5H8C3.85786 87.5 0.5 84.1421 0.5 80V8C0.5 3.85786 3.85786 0.5 8 0.5Z",
    stroke: "#042761"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.25,
    y: 19.25,
    width: 26.5,
    height: 49.5,
    stroke: "#042761",
    strokeWidth: 1.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_176_297",
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 26,
    width: 26,
    height: 44,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 45,
    y: 26,
    width: 26,
    height: 44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 28H69V68H45V28Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69 28H70.5V26.5H69V28ZM69 68V69.5H70.5V68H69ZM45 28V29.5H69V28V26.5H45V28ZM69 28H67.5V68H69H70.5V28H69ZM69 68V66.5H45V68V69.5H69V68Z",
    fill: "#042761",
    mask: "url(#path-3-outside-1_176_297)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.25,
    y: 29.25,
    width: 7.5,
    height: 7.5,
    stroke: "#042761",
    strokeWidth: 1.5
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-outside-2_176_297",
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 37,
    width: 10,
    height: 8,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 22,
    y: 37,
    width: 10,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 37H30V43H24V37Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 43V44.5H31.5V43H30ZM24 43H22.5V44.5H24V43ZM30 37H28.5V43H30H31.5V37H30ZM30 43V41.5H24V43V44.5H30V43ZM24 43H25.5V37H24H22.5V43H24Z",
    fill: "#042761",
    mask: "url(#path-6-outside-2_176_297)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-outside-3_176_297",
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 44,
    width: 10,
    height: 8,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 22,
    y: 44,
    width: 10,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 44H30V50H24V44Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 50V51.5H31.5V50H30ZM24 50H22.5V51.5H24V50ZM30 44H28.5V50H30H31.5V44H30ZM30 50V48.5H24V50V51.5H30V50ZM24 50H25.5V44H24H22.5V50H24Z",
    fill: "#042761",
    mask: "url(#path-8-outside-3_176_297)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 29.25,
    width: 7.5,
    height: 7.5,
    stroke: "#042761",
    strokeWidth: 1.5
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-outside-4_176_297",
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 37,
    width: 10,
    height: 8,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 30,
    y: 37,
    width: 10,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 37H38V43H32V37Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38 43V44.5H39.5V43H38ZM32 43H30.5V44.5H32V43ZM38 37H36.5V43H38H39.5V37H38ZM38 43V41.5H32V43V44.5H38V43ZM32 43H33.5V37H32H30.5V43H32Z",
    fill: "#042761",
    mask: "url(#path-11-outside-4_176_297)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-outside-5_176_297",
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 44,
    width: 10,
    height: 8,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 30,
    y: 44,
    width: 10,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 44H38V50H32V44Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38 50V51.5H39.5V50H38ZM32 50H30.5V51.5H32V50ZM38 44H36.5V50H38H39.5V44H38ZM38 50V48.5H32V50V51.5H38V50ZM32 50H33.5V44H32H30.5V50H32Z",
    fill: "#042761",
    mask: "url(#path-13-outside-5_176_297)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 49.25,
    y: 32.25,
    width: 7.5,
    height: 7.5,
    stroke: "#042761",
    strokeWidth: 1.5
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-16-outside-6_176_297",
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 40,
    width: 10,
    height: 8,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 48,
    y: 40,
    width: 10,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 40H56V46H50V40Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46V47.5H57.5V46H56ZM50 46H48.5V47.5H50V46ZM56 40H54.5V46H56H57.5V40H56ZM56 46V44.5H50V46V47.5H56V46ZM50 46H51.5V40H50H48.5V46H50Z",
    fill: "#042761",
    mask: "url(#path-16-outside-6_176_297)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 57.25,
    y: 32.25,
    width: 7.5,
    height: 7.5,
    stroke: "#042761",
    strokeWidth: 1.5
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-19-outside-7_176_297",
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 40,
    width: 10,
    height: 8,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 56,
    y: 40,
    width: 10,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 40H64V46H58V40Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46V47.5H65.5V46H64ZM58 46H56.5V47.5H58V46ZM64 40H62.5V46H64H65.5V40H64ZM64 46V44.5H58V46V47.5H64V46ZM58 46H59.5V40H58H56.5V46H58Z",
    fill: "#042761",
    mask: "url(#path-19-outside-7_176_297)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-21-outside-8_176_297",
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 55,
    width: 12,
    height: 14,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 26,
    y: 55,
    width: 12,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 61C28 58.7909 29.7909 57 32 57C34.2091 57 36 58.7909 36 61V69H28V61Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 61C26.5 57.9624 28.9624 55.5 32 55.5C35.0376 55.5 37.5 57.9624 37.5 61H34.5C34.5 59.6193 33.3807 58.5 32 58.5C30.6193 58.5 29.5 59.6193 29.5 61H26.5ZM29.5 61M36 69H28H36M26.5 69V61C26.5 57.9624 28.9624 55.5 32 55.5V58.5C30.6193 58.5 29.5 59.6193 29.5 61V69H26.5ZM32 55.5C35.0376 55.5 37.5 57.9624 37.5 61V69H34.5V61C34.5 59.6193 33.3807 58.5 32 58.5V55.5Z",
    fill: "#042761",
    mask: "url(#path-21-outside-8_176_297)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4995 56.1897C60.0307 56.1897 62.0833 58.2416 62.0835 60.7727V68.3762H52.9165V60.7727C52.9167 58.2417 54.9685 56.1899 57.4995 56.1897Z",
    stroke: "#042761",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpIcon3);
export default __webpack_public_path__ + "static/media/expIcon3.35c6a48a8df990e960a31bac91add093.svg";
export { ForwardRef as ReactComponent };